import React from 'react';

const Dashboard = () => {
  return (
    <div style={{
      backgroundColor: '#f8f9fa',
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
    }}>
      
      {/* ---- Metric Cards ---- */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '20px',
        marginBottom: '30px',
      }}>
        <MetricCard title="Total Appointments" value="120" color="#33b18a" />
        <MetricCard title="Pending Consultations" value="18" color="#ff9800" />
        <MetricCard title="Completed Consultations" value="92" color="#4caf50" />
        <MetricCard title="Cancelled / No-Show" value="10" color="#f44336" />
      </div>

      {/* ---- Charts Section ---- */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: '2fr 1fr',
        gap: '20px',
        marginBottom: '30px'
      }}>
        <div style={{
          backgroundColor: '#fff',
          borderRadius: '10px',
          boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
          padding: '20px',
          display: 'flex',
          gap: '20px',
        }}>
          <div style={{ flex: 1 }}>
            <h3 style={{ fontSize: '16px', marginBottom: '15px', color: '#555' }}>Patients by Department</h3>
            <div style={{
              height: '180px',
              backgroundColor: '#e0e0e0',
              borderRadius: '5px',
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'space-around',
              padding: '10px',
            }}>
              <Bar height="70%" label="Cardiology" />
              <Bar height="50%" label="Dermatology" />
              <Bar height="60%" label="Orthopedics" />
              <Bar height="40%" label="ENT" />
              <Bar height="80%" label="General Medicine" />
            </div>
          </div>

          <div style={{ flex: 1 }}>
            <h3 style={{ fontSize: '16px', marginBottom: '15px', color: '#555' }}>Patient Age Distribution</h3>
            <div style={{
              height: '180px',
              backgroundColor: '#e0e0e0',
              borderRadius: '5px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
            }}>
              <DonutChart />
            </div>
          </div>
        </div>

        <div style={{
          backgroundColor: '#fff',
          borderRadius: '10px',
          boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
          padding: '20px',
        }}>
          <h3 style={{ fontSize: '16px', marginBottom: '15px', color: '#555' }}>Upcoming Surgeries</h3>
          <ul style={{ listStyle: 'none', padding: 0, fontSize: '14px', color: '#555' }}>
            <li>12:00 PM - Heart Bypass - Dr. Anil Kumar</li>
            <li>02:00 PM - Knee Replacement - Dr. Naresh Gupta</li>
            <li>03:30 PM - Appendectomy - Dr. Krishna J</li>
            <li>04:00 PM - Skin Biopsy - Dr. Ramya Krishna</li>
          </ul>
        </div>
      </div>

      {/* ---- Table Section ---- */}
      <div style={{
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
      }}>
        <h3 style={{ marginBottom: '15px', color: '#555' }}>Patient Appointments</h3>

        <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          fontSize: '14px'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#33b18a', color: '#fff' }}>
              <th style={thStyle}>S.No</th>
              <th style={thStyle}>Date</th>
              <th style={thStyle}>Patient Name</th>
              <th style={thStyle}>Mobile Number</th>
              <th style={thStyle}>Department</th>
              <th style={thStyle}>Doctor Assigned</th>
              <th style={thStyle}>Status</th>
            </tr>
          </thead>
          <tbody>
            {staticData.map((row, index) => (
              <tr key={index} style={{ borderBottom: '1px solid #ddd' }}>
                <td style={tdStyle}>{row.sno}</td>
                <td style={tdStyle}>{row.date}</td>
                <td style={tdStyle}>{row.name}</td>
                <td style={tdStyle}>{row.mobile}</td>
                <td style={tdStyle}>{row.dept}</td>
                <td style={tdStyle}>{row.doctor}</td>
                <td style={tdStyle}>{row.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
};

/* ---------- Static Table Data ---------- */
const staticData = [
  { sno: 1, date: "2025-01-15", name: "Anil Kumar", mobile: "9876543210", dept: "Cardiology", doctor: "Dr. Anil Kumar", status: "Completed" },
  { sno: 2, date: "2025-01-16", name: "Ramya Krishna", mobile: "9123456780", dept: "Dermatology", doctor: "Dr. Ramya Krishna", status: "Pending" },
  { sno: 3, date: "2025-01-17", name: "Naresh Gupta", mobile: "9988776655", dept: "Orthopedics", doctor: "Dr. Naresh Gupta", status: "Completed" },
  { sno: 4, date: "2025-01-18", name: "Krishna J", mobile: "9090909090", dept: "ENT", doctor: "Dr. Krishna J", status: "Cancelled" },
  { sno: 5, date: "2025-01-19", name: "Damodhar", mobile: "9876501234", dept: "General Medicine", doctor: "Dr. Damodhar", status: "Pending" }
];

const thStyle = { padding: '10px', textAlign: 'left' };
const tdStyle = { padding: '10px', color: '#555' };

/* ---------- Reusable Components ---------- */

const MetricCard = ({ title, value, color }) => (
  <div style={{
    backgroundColor: color,
    borderRadius: '10px',
    padding: '20px',
    color: '#fff',
    textAlign: 'center',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
  }}>
    <div style={{ fontSize: '36px', fontWeight: 'bold', marginBottom: '5px' }}>{value}</div>
    <div style={{ fontSize: '16px' }}>{title}</div>
  </div>
);

const Bar = ({ height, label }) => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: '100%',
  }}>
    <div style={{
      width: '20px',
      height: height,
      backgroundColor: '#33b18a',
      borderRadius: '3px',
    }}></div>
    <div style={{ fontSize: '10px', marginTop: '5px', color: '#555' }}>{label}</div>
  </div>
);

const DonutChart = () => (
  <div style={{
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    background: `conic-gradient(
      #66c2a5 0% 40%,
      #fc8d62 40% 60%,
      #8da0cb 60% 80%,
      #e78ac3 80% 100%
    )`,
  }}></div>
);

export default Dashboard;
